import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_DISCOUNT_SAGA } from "../sagaTypes";
import { loaderAction, discountFormAction, typeOpenSettingsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_discount`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetDiscount(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('discount_id', args.data.discount_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Добавляем данные о скидке в форму
            yield put(discountFormAction(response.discount));
            // Открываем форму редактирования скидки
            yield put(typeOpenSettingsFormAction('discount'));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetDiscount() {
    yield takeLatest(GET_DISCOUNT_SAGA, workerGetDiscount);
}